import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { m } from "./tss-DN0acMKN.mjs";
import { M as a, d as n } from "./constants-CnFYFetN.mjs";
import { I as i } from "./InputAdornment-T4xPPRnD.mjs";
const p = m()((o) => {
  const { mode: s } = o;
  return {
    root: {
      outline: s === a.Dye ? `1px solid ${n.main}` : void 0
    }
  };
}), f = ({ children: o, position: s = "start", ...t }) => {
  const { classes: r } = p();
  return /* @__PURE__ */ e.jsx(i, { className: r.root, ...t, "data-fabric-component": "Nub", position: s, children: o });
};
export {
  f as N
};
//# sourceMappingURL=nub-h9wiBv_F.mjs.map
